(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    // Tops up the sidebar's products block with Shopify recommendations,
    // anchored on the first product already shown. Skips duplicates.
    Alpine.data('articleRecs', () => ({
      async init() {
        const anchor = this.$el.querySelector('[data-anchor]');
        const pid = anchor && anchor.dataset.anchor;
        const limit = Number(this.$el.dataset.limit) || 3;
        const list = this.$refs.list;
        const have = new Set(Array.from(list.querySelectorAll('[data-product-id]')).map((n) => n.dataset.productId));
        if (!pid || have.size >= limit) return;
        try {
          const url = `${this.$el.dataset.recsUrl}?section_id=article-recommendations&product_id=${pid}&limit=10&intent=related`;
          const res = await fetch(url);
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          for (const node of doc.querySelectorAll('[data-product-id]')) {
            if (have.size >= limit) break;
            if (have.has(node.dataset.productId)) continue;
            have.add(node.dataset.productId);
            list.appendChild(node);
          }
        } catch (e) {}
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('proofHeader', () => ({
      openIndex: null,
      mobileOpen: false,
      closeAll() {
        this.openIndex = null;
        this.mobileOpen = false;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('productGallery', () => ({
      active: 0,
      init() {
        // When the buy box resolves a new variant, jump to that variant's image.
        this.$el.addEventListener('variant:changed', (e) => {
          // `product | json` exposes variant.featured_image (with a 1-based
          // position among the product's images), not featured_media.
          const img = e.detail.variant && e.detail.variant.featured_image;
          if (!img) return;
          if (typeof img.position === 'number') {
            this.active = img.position - 1;
          }
        });
      },
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
